<div class="cl-templates">
    <div class="cl-card" *ngFor="let cl of generatedCls; let i = index">
        <img [src]="getImageUrl(cl.imagePath)" alt="{{ 'common.clTemplate' | translate }} {{ i + 1 }}"
            (contextmenu)="disableRightClick($event)" />

        <div class="buttons">

            <!-- If paid and Word exists -->
            <button *ngIf="cl.isPaid && cl.wordPath; else checkPdfOrBuy" class="word_download"
                (click)="downloadFile(cl.wordPath)">
                {{ "Download Word" | translate }}
            </button>

            <!-- Else if paid and PDF exists -->
            <ng-template #checkPdfOrBuy>
                <button *ngIf="cl.isPaid && cl.pdfPath; else notPaid" class="word_download"
                    (click)="downloadFile(cl.pdfPath)">
                    {{ "Download PDF" | translate }}
                </button>
            </ng-template>

            <!-- Else not paid -->
            <ng-template #notPaid>
                <button class="word_download" (click)="makeOrder(cl.id, 'generate-cl')">
                    {{ "Buy" | translate }}
                </button>
            </ng-template>

        </div>
    </div>
</div>